const elementorSticky = document.querySelectorAll('.internal-sticky-header');

elementorSticky.forEach((stickyItem) => {
	const sticky = () => {
		const top = window.pageYOffset || document.documentElement.scrollTop;
		if (top > 20) {
			stickyItem.classList.add('internal-sticky-header--offset-top');
		} else {
			stickyItem.classList.remove('internal-sticky-header--offset-top');
		}
	};
	window.addEventListener('scroll', sticky);
});
